window.footerScrollHiddenAnimation = function footerScrollHiddenAnimation() {
  const headerBottomComponent = document.querySelector('.header-bottom');
  const footerEl = document.querySelector('footer');
  const btnToTop = document.querySelector('.btn-to-top');
  const btnCall = document.querySelector('.btn-call');

  if (!headerBottomComponent || !footerEl) return;

  setTimeout(() => {
    headerBottomComponent.querySelector(
      '.header-bottom__wrap'
    ).style.transitionDelay = '0s';
  }, 500);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const isIntersecting = entry.isIntersecting;

        if (isIntersecting) {
          headerBottomComponent.classList.remove('is-visible');
          btnToTop?.classList.add('is-hidden');
          btnCall?.classList.add('is-hidden');
        } else {
          headerBottomComponent.classList.add('is-visible');
          btnToTop?.classList.remove('is-hidden');
          btnCall?.classList.remove('is-hidden');
        }
      });
    },
    {
      root: null,
      threshold: 0,
    }
  );

  observer.observe(footerEl);
};
const footerTitleMemory = {
  savedContent: null,
};

function saveFooterTitleContent() {
  const footerTitleWr = document.querySelector('.footer__title-wr');

  if (!footerTitleWr) {
    return;
  }

  footerTitleMemory.savedContent = footerTitleWr.innerHTML;
}

function restoreFooterTitleContent() {
  const footerTitleWr = document.querySelector('.footer__title-wr');

  if (!footerTitleWr) {
    return;
  }

  if (footerTitleMemory.savedContent === null) {
    return;
  }

  footerTitleWr.innerHTML = footerTitleMemory.savedContent;
}

saveFooterTitleContent();

window.globalFooterTitleFunc = function globalFooterTitleFunc() {
  const footerTitleWr = document.querySelector('.footer__title-wr');

  if (footerTitleWr) {
    if (typeof destroyScrollBlurAnimation === 'function') {
      destroyScrollBlurAnimation(footerTitleWr);
    }

    restoreFooterTitleContent();
    initScrollBlurAnimation(footerTitleWr);
  }
};
